import React from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import windows from 'assets/windowsIcons/windows.png';
import outlook from 'assets/windowsIcons/887(16x16).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import go from 'assets/windowsIcons/290.png';

function Contact({ onClose }) {
  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
  }
  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img src={outlook} alt="" className="com__address_bar__content__img" />
          <div className="com__address_bar__content__text">Outlook Express — Inbox</div>
          <img src={dropdown} alt="" className="com__address_bar__content__img" />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>
      <div className="com__content">
        <div className="mail-container">
          <div className="mail-header">
            <div className="mail-row"><span className="mail-label">From:</span> Mahip Kakan &lt;mahip.ku.kakan@gmail.com&gt;</div>
            <div className="mail-row"><span className="mail-label">To:</span> You (yes, you)</div>
            <div className="mail-row"><span className="mail-label">Subject:</span> Re: Let's build something with AI that actually works</div>
            <div className="mail-row"><span className="mail-label">Status:</span> <span className="status-open">🟢 Open to product conversations, AI collaborations, and well-crafted cold emails</span></div>
          </div>
          <div className="mail-body">
            <p>Hey — glad you made it this far without hitting Close on the wrong window.</p>
            <p>
              I work at the intersection of AI product strategy, enterprise transformation, and
              getting-stuff-actually-shipped. If you're building something real with GenAI, running a team that needs
              a PM who speaks both business and LLM, or just want to talk agentic AI over coffee — I'm in.
            </p>
            <div className="contact-list">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:mahip.ku.kakan@gmail.com">mahip.ku.kakan@gmail.com</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:+917735544556">+91 77355 44556</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">💼</span>
                <a href="https://www.linkedin.com/in/mahip-kakan/" target="_blank" rel="noreferrer">linkedin.com/in/mahip-kakan</a>
              </div>
              <a
                className="libutton"
                href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7446461748267630592"
                target="_blank"
                rel="noreferrer"
              >
                Subscribe on LinkedIn
              </a>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Bengaluru, Karnataka</span>
              </div>
            </div>
            <p className="ps-note">P.S. — I respond faster than most enterprise AI deployments.</p>
          </div>
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative; display: flex; align-items: center;
    height: 24px; border-bottom: 1px solid rgba(255,255,255,0.7); flex-shrink: 0;
  }
  .com__options {
    height: 23px; border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1); padding: 1px 0 1px 2px; flex: 1;
  }
  .com__windows-logo { height: 100%; border-left: 1px solid white; border-bottom: 1px solid rgba(0,0,0,0.1); }
  .com__address_bar {
    flex-shrink: 0; border-top: 1px solid rgba(255,255,255,0.7); height: 20px;
    font-size: 11px; display: flex; align-items: center; padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title { color: rgba(0,0,0,0.5); padding: 5px; }
  .com__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid; height: 100%; display: flex; flex: 1;
    align-items: center; background-color: white; position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { white-space: nowrap; position: absolute; left: 16px; right: 17px; }
  }
  .com__address_bar__go {
    display: flex; align-items: center; padding: 0 18px 0 5px; height: 100%; position: relative;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .com__content {
    flex: 1; border: 1px solid rgba(0,0,0,0.4); border-top-width: 0;
    background-color: #fff; overflow: auto; font-size: 11px;
  }
  .mail-container { display: flex; flex-direction: column; height: 100%; }
  .mail-header {
    background: linear-gradient(180deg, #f0f4ff 0%, #e4ecff 100%);
    border-bottom: 2px solid #c0d0f0;
    padding: 10px 16px;
    font-size: 11px;
  }
  .mail-row { margin-bottom: 4px; }
  .mail-label { font-weight: bold; color: #0a3d90; margin-right: 6px; }
  .status-open { color: #006600; font-weight: bold; }
  .mail-body {
    flex: 1; padding: 16px; font-size: 12px; line-height: 1.6; color: #222;
    p { margin: 0 0 12px; }
  }
  .contact-list { margin: 14px 0; display: flex; flex-direction: column; gap: 8px; }
  .contact-item {
    display: flex; align-items: center; gap: 10px;
    padding: 6px 12px;
    background: linear-gradient(180deg, #f9fcff 0%, #eef6ff 100%);
    border: 1px solid #c4d9f8;
    font-size: 12px;
  }
  .contact-icon { font-size: 16px; }
  a { color: #0046ad; text-decoration: none; font-size: 12px; }
  a:hover { text-decoration: underline; }
  .libutton {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 4px 0 8px;
    padding: 7px;
    text-align: center;
    outline: none;
    text-decoration: none !important;
    color: #ffffff !important;
    width: 200px;
    height: 32px;
    border-radius: 16px;
    background-color: #0A66C2;
    font-family: "SF Pro Text", Helvetica, sans-serif;
    font-size: 13px;
    line-height: 1;
    box-sizing: border-box;
  }
  .libutton:hover {
    color: #ffffff !important;
    text-decoration: none !important;
    filter: brightness(1.08);
  }
  .ps-note { font-style: italic; color: #888; font-size: 11px; margin-top: 16px !important; }
`;

export default Contact;
